// extracted by css-extract-rspack-plugin
export default {"wrapper":"OFYlZ","ad_container":"Nz0D7","adContainer":"Nz0D7","top_bar":"_lnAb","topBar":"_lnAb","close_button":"w1Roa","closeButton":"w1Roa"};